import distributors from './distributors';
import laboratories from './laboratories';
import movies from './movies';

export default {
  namespaced: true,

  modules: {
    distributors,
    laboratories,
    movies,
  },
};
